<template>
    <div>
        <div ref="pageBox">
            <SearchBox ref="SearchBox">
                <el-form slot="form" :inline="true" ref="searchData" :model="searchParams" label-width="100px"
                         class="unitWidth" size="small">
                    <el-form-item label="所属工厂">
                        <el-select v-model="fcIdSelected" placeholder="请选择" :clearable="isclear" :disabled="ischeck"
                                   filterable @change="fcChange">
                            <el-option
                                v-for="factory in factoryList"
                                :key="factory.value"
                                :label="factory.label"
                                :value="factory.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属车间">
                        <el-select v-model="shopSelected" placeholder="请选择" clearable filterable @change="shopChange">
                            <el-option
                                v-for="shop in shopList"
                                :key="shop.value"
                                :label="shop.label"
                                :value="shop.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属工段">
                        <el-select v-model="sectionSelected" placeholder="请选择" clearable filterable
                                   @change="sectionChange">
                            <el-option
                                v-for="section in sectionList"
                                :key="section.value"
                                :label="section.label"
                                :value="section.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属产线">
                        <el-select v-model="lineSelected" placeholder="请选择" clearable filterable @change="lineChange">
                            <el-option
                                v-for="line in lineList"
                                :key="line.value"
                                :label="line.label"
                                :value="line.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="设备编号">
                        <el-input v-model.trim="devCode" placeholder="请输入设备编号"></el-input>
                    </el-form-item>
                    <el-form-item label="设备名称">
                        <el-input v-model.trim="devName" placeholder="请输入设备名称"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="searchTable">查询</el-button>
                    </el-form-item>
                </el-form>
            </SearchBox>
        </div>
        <LabelContent title="历史经验" ref="LabelContent">
            <div slot="btns">
                <!--<el-button size="small" type="success">导出</el-button>-->
                <el-button size="small" type="success" @click=";(repairAdd = true), updateRepair()"
                           v-for="acc in access" v-if="acc == 'HISEXPADD001'"> 新增
                </el-button>
            </div>
        </LabelContent>
        <div class="tableBox">
            <el-table stripe ref="multipleTable" :data="tableData" class="center"
                      @selection-change="handleSelectionChange" @sort-change="sortChange">
                <el-table-column prop="fcName" label="工厂名称" show-overflow-tooltip/>
                <el-table-column prop="shopName" label="车间名称"/>
                <el-table-column prop="sectionName" label="工段名称"/>
                <el-table-column prop="lineName" label="产线名称"/>
                <el-table-column prop="devCode" label="设备编码"/>
                <el-table-column prop="devName" label="设备名称"/>
                <el-table-column prop="faultCode" label="关联故障代码" width="110"/>
                <el-table-column prop="repairPhenomenon" label="故障现象"/>
                <el-table-column prop="repairReason" label="故障愿意分析" width="110"/>
                <el-table-column prop="repairResolvent" label="故障解决方法" width="110"/>
                <el-table-column prop="repairOccurrenceTime" label="故障发现时间" width="110" show-overflow-tooltip/>
                <el-table-column prop="updFile" label="相关附件" width="160" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <a v-for="file in scope.row.updFile" style="color: #63a35c" :href="file">{{ file }}<br/></a>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="160"/>
                <el-table-column label="操作" width="120" fixed="right">
                    <template slot-scope="scope">
                        <i class="editBtn iconfont u-youjianbianji"
                           @click=";(repairAdd = false), updateRepair(scope.row)" v-for="acc in access"
                           v-if="acc == 'HISEXPEDIT002'"/>
                        <i class="delBtn iconfont u-shanchu" @click="delRepair(scope.row)" v-for="acc in access"
                           v-if="acc == 'HSIEXPDEL001'"/>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
            @size-change="paginationChange"
            @current-change="paginationCurrentChange"
            :current-page="searchParams.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="searchParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="searchParams.pageCount"
        />
        <!--新增历史经验-->
        <el-dialog :title="repairAdd ? '新增' : '修改'" width="50vw" :visible.sync="repairShow" style="text-align: left">
            <el-form :model="repairExp" :rules="repair" ref="repair" label-width="110px" class="demo-roleForm">
                <el-form-item label="设备编码" prop="devCode">
                    <el-input v-model.trim="repairExp.devCode" placeholder="请输入设备编码"></el-input>
                </el-form-item>
                <el-form-item label="关联故障代码">
                    <el-input v-model.trim="repairExp.faultCode" placeholder="请输入关联故障代码"></el-input>
                </el-form-item>
                <el-form-item label="故障现象" prop="repairPhenomenon">
                    <el-input v-model.trim="repairExp.repairPhenomenon" placeholder="请输入故障现象"></el-input>
                </el-form-item>
                <el-form-item label="故障原因分析" prop="repairReason">
                    <el-input v-model.trim="repairExp.repairReason" placeholder="请输入故障原因分析"></el-input>
                </el-form-item>
                <el-form-item label="故障解决方法" prop="repairResolvent">
                    <el-input v-model.trim="repairExp.repairResolvent" placeholder="请输入故障解决方法"></el-input>
                </el-form-item>
                <el-form-item label="故障发生时间" prop="repairOccurrenceTime">
                    <el-date-picker v-model="repairExp.repairOccurrenceTime" type="datetime"
                                    placeholder="选择故障发生时间"></el-date-picker>
                </el-form-item>
                <el-form-item label="相关附件">
                    <el-upload v-show="repairFileUpload" :headers="{ 'X-Auth-Token': token }" :action="URL"
                               :on-success="handleSuccessRepair" :on-remove="delImg" :file-list="fileList">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                    <!--                    <el-input v-show="fileUrlShow" v-model="deviceFile.fileUrl" disabled></el-input>-->
                    <!--                        <span v-show="repairFileUploadShow">{{repairExp.updFile}}</span>-->
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="repairShow = false">取 消</el-button>
                <el-button type="primary" @click="saveRepairExp('repair')" :disabled="saveShow">{{ repairAdd ? '新增' : '修改' }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        name: 'historicalExp',
        data() {
            return {
                saveShow: false,
                searchParams: {
                    param: {},
                    pageSize: 10,
                    page: 1,
                    pageCount: 0
                },
                tableData: [],
                factoryTree: [],
                fcIdSelected: '',
                sectionSelected: '',
                shopSelected: '',
                lineSelected: '',
                devCode: '',
                devName: '',
                userInfo: {},
                role: {},
                ischeck: true,
                isclear: false,
                updateShow: false,
                repairExpList: [],
                repairAdd: false,
                repairShow: false,
                repairExp: {
                    devCode: '',
                    faultCode: '',
                    repairPhenomenon: '',
                    repairReason: '',
                    repairResolvent: '',
                    repairOccurrenceTime: '',
                    updFile: '',
                    isActive: ''
                },
                repair: {
                    devCode: [
                        {
                            required: true,
                            message: '请输入设备编码',
                            trigger: 'blur'
                        }
                    ],
                    repairPhenomenon: [
                        {
                            required: true,
                            message: '请输入故障现象',
                            trigger: 'blur'
                        }
                    ],
                    repairReason: [
                        {
                            required: true,
                            message: '请输入故障原因分析',
                            trigger: 'blur'
                        }
                    ],
                    repairResolvent: [
                        {
                            required: true,
                            message: '请输入故障解决方法',
                            trigger: 'blur'
                        }
                    ],
                    repairOccurrenceTime: [
                        {
                            required: true,
                            message: '请选择故障发生时间',
                            trigger: 'blur'
                        }
                    ]
                },
                repairFileUploadShow: false,
                repairFileUpload: true,
                URL: '',
                token: '',
                fileList: [],
                access: []
            }
        },
        computed: {
            factoryList: function() {
                var arr = []
                var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                if (this.factoryTree != undefined && this.factoryTree.length > 0) {
                    if (this.ischeck) {
                        for (var i = 0; i < this.factoryTree.length; i++) {
                            for (let j = 0; j < userInfo.roles.length; j++) {
                                if (this.factoryTree[i].deptID == userInfo.roles[j].factoryId) {
                                    arr.push({
                                        label: this.factoryTree[i].deptName,
                                        id: this.factoryTree[i].deptID,
                                        value: JSON.stringify(this.factoryTree[i]),
                                        deptLevel: this.factoryTree[i].deptLevel,
                                        parent: 0
                                    })
                                }
                            }
                        }
                    } else {
                        for (var i = 0; i < this.factoryTree.length; i++) {
                            arr.push({
                                label: this.factoryTree[i].deptName,
                                id: this.factoryTree[i].deptID,
                                value: JSON.stringify(this.factoryTree[i]),
                                deptLevel: this.factoryTree[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            shopList: function() {
                var arr = []
                if (this.fcIdSelected != undefined && this.fcIdSelected.length > 0) {
                    var factory = JSON.parse(this.fcIdSelected)
                    var shops = factory.child
                    for (var i = 0; i < shops.length; i++) {
                        if (shops[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: shops[i].deptName,
                                id: shops[i].deptID,
                                value: JSON.stringify(shops[i]),
                                deptLevel: shops[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            sectionList: function() {
                var arr = []
                if (this.shopSelected != undefined && this.shopSelected.length > 0) {
                    var shop = JSON.parse(this.shopSelected)
                    var vsms = shop.child
                    for (var i = 0; i < vsms.length; i++) {
                        if (vsms[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: vsms[i].deptName,
                                id: vsms[i].deptID,
                                value: JSON.stringify(vsms[i]),
                                deptLevel: vsms[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            lineList: function() {
                var arr = []
                if (this.sectionSelected != undefined && this.sectionSelected.length > 0) {
                    var vsm = JSON.parse(this.sectionSelected)
                    var lines = vsm.child
                    for (var i = 0; i < lines.length; i++) {
                        if (lines[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: lines[i].deptName,
                                id: lines[i].deptID,
                                value: JSON.stringify(lines[i]),
                                deptLevel: lines[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            }
        },
        mounted() {
            this.init()
        },
        methods: {
            init() {
                this.access = JSON.parse(sessionStorage.getItem('auths'))
                this.URL = 'https://tpm.joysonsafety.com.cn/api/upload/files'
                // this.URL = 'https://tpm.joysonsafety.com.cn/back/api/upload/files'
                // this.URL = this.$api.uplodFiles
                this.token = sessionStorage.getItem('authToken')
                this.userInfo = this.$store.state.userInfo
                var role = this.userInfo.roles
                for (var i = 0; i < role.length; i++) {
                    //所有工厂数据
                    if (role[i].factoryId == 0) {
                        this.ischeck = false
                        this.isclear = true
                        this.role = role[i]
                        break
                    } else {
                        if (this.userInfo.factoryId == role[i].factoryId) {
                            this.role = role[i]
                        }
                    }
                }
                this.getData()
            },
            updateRepair(row) {
                this.fileList = []
                if (this.repairAdd) {
                    this.repairExp = {}
                    this.repairFileUploadShow = true
                    this.repairFileUpload = true
                } else {
                    this.repairExp = JSON.parse(JSON.stringify(row))
                    let str = ''
                    for (let i = 0; i < this.repairExp.updFile.length; i++) {
                        str += this.repairExp.updFile[i] + ','
                        this.fileList.push({ name: this.repairExp.updFile[i], url: this.repairExp.updFile[i] })
                    }
                    str = str.substring(0, str.length - 1)
                    this.repairExp.updFile = str
                    this.repairFileUploadShow = true
                    this.repairFileUpload = true
                }
                this.repairShow = true
            },
            handleSuccessRepair(res, file) {
                let str = ''
                this.fileList.push({ name: file.name, url: file.response.data })
                for (let i = 0; i < this.fileList.length; i++) {
                    str += this.fileList[i].url + ','
                }
                str = str.substring(0, str.length - 1)
                this.repairExp.updFile = str
                if (this.repairAdd) {
                    this.repairFileUploadShow = true
                    this.repairFileUpload = true
                } else {
                    this.repairFileUploadShow = true
                    this.repairFileUpload = true
                }
            },
            delImg(file, fileList) {
                let str = ''
                this.fileList = fileList
                for (let i = 0; i < this.fileList.length; i++) {
                    str += this.fileList[i].url + ','
                    console.log('this.fileList[i].url', this.fileList[i].url)
                }
                str = str.substring(0, str.length - 1)
                this.repairExp.updFile = str
                console.log('this.fileList', this.fileList)
                console.log('this.repairExp.updFile', this.repairExp.updFile)
            },
            saveRepairExp(repair) {
                this.$refs[repair].validate((valid) => {
                    if (valid) {
                        if (this.repairExp.updFile == undefined || this.repairExp.updFile == '') {
                            this.$message.error('请选择文件！')
                            return
                        }
                        this.repairExp.repairOccurrenceTime = moment(this.repairExp.repairOccurrenceTime).format('YYYY-MM-DD HH:mm:ss')
                        this.saveShow = true
                        let options = {
                            method: 'POST',
                            url: this.repairAdd ? this.$api.addRepairExp : this.$api.editRepairExp,
                            data: this.repairExp
                        }
                        this.$http.request(options).then(response => {
                            this.saveShow = false
                            if (response.status == 100) {
                                this.repairShow = false
                                this.searchTable()
                                this.$message.success(this.repairAdd ? '新增成功!' : '编辑成功！')
                            } else {
                                this.$message.error(response.message)
                            }
                        })
                    } else {
                        return false
                    }
                })
            },
            delRepair(row) {
                this.$confirm('是否确定删除该数据, 是否继续?', '提示', {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.$http
                            .request({
                                method: 'POST',
                                params: {
                                    dreId: row.dreId
                                },
                                url: this.$api.deleteRepairExp
                            })
                            .then(response => {
                                this.searchTable()
                                // this.$message.success(response.message);
                            })
                            .catch(err => {
                                this.searchTable()
                                // this.$message.error(err);
                            })
                    })
                    .catch(() => {
                        this.searchTable()
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        })
                    })
            },
            //多选框选择 返回当前已选行数据(Array)
            handleSelectionChange(val) {
                console.log(val)
            },
            //从后台获取数据,重新排序
            sortChange(val) {
                // 详细文档参考： https://element.eleme.cn/2.13/#/zh-CN/component/table
                console.log(val)
            },
            //分页
            paginationChange(val) {
                this.searchParams.pageSize = val
                this.searchTable()
            },
            paginationCurrentChange(val) {
                this.searchParams.page = val
                this.searchTable()
            },
            fcChange: function() {
                this.shopSelected = ''
                this.sectionSelected = ''
                this.lineSelected = ''
                this.searchTable()
            },
            shopChange: function() {
                this.sectionSelected = ''
                this.lineSelected = ''
                this.searchTable()
            },
            sectionChange: function() {
                this.lineSelected = ''
                this.searchTable()
            },
            lineChange: function() {
                this.searchTable()
            },
            searchTable() {
                this.tableData = []
                let queryParams = {
                    pageSize: this.searchParams.pageSize,
                    pageNum: this.searchParams.page
                }
                var self = this
                if (self.fcIdSelected != undefined && self.fcIdSelected != '') {
                    queryParams['fcCode'] = JSON.parse(self.fcIdSelected).deptCode
                }
                if (self.shopSelected != undefined && self.shopSelected != '') {
                    queryParams['shopCode'] = JSON.parse(self.shopSelected).deptCode
                }
                if (self.sectionSelected != undefined && self.sectionSelected != '') {
                    queryParams['sectionCode'] = JSON.parse(self.sectionSelected).deptCode
                }
                if (self.lineSelected != undefined && self.lineSelected != '') {
                    queryParams['lineCode'] = JSON.parse(self.lineSelected).deptCode
                }
                if (self.devCode != undefined && self.devCode != '') {
                    queryParams['devCode'] = self.devCode
                }
                if (self.devName != undefined && self.devName != '') {
                    queryParams['devName'] = self.devName
                }
                let options = {
                    method: 'get',
                    url: this.$api.getAllRepairExp,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        if (response.data != undefined && response.data != '') {
                            let arr = response.data.list
                            for (let i = 0; i < arr.length; i++) {
                                let array = {
                                    dreId: '',
                                    devCode: '',
                                    devName: '',
                                    fcName: '',
                                    shopName: '',
                                    sectionName: '',
                                    lineName: '',
                                    faultCode: '',
                                    repairPhenomenon: '',
                                    repairReason: '',
                                    repairResolvent: '',
                                    repairOccurrenceTime: '',
                                    updFile: [],
                                    createTime: '',
                                    isActive: '',
                                    isDeleted: ''
                                }
                                array.dreId = arr[i].dreId
                                array.devCode = arr[i].devCode
                                array.devName = arr[i].devName
                                array.fcName = arr[i].fcName
                                array.shopName = arr[i].shopName
                                array.sectionName = arr[i].sectionName
                                array.lineName = arr[i].lineName
                                array.faultCode = arr[i].faultCode
                                array.repairPhenomenon = arr[i].repairPhenomenon
                                array.repairReason = arr[i].repairReason
                                array.repairResolvent = arr[i].repairResolvent
                                array.repairOccurrenceTime = arr[i].repairOccurrenceTime
                                array.createTime = arr[i].createTime
                                array.isActive = arr[i].isActive
                                array.isDeleted = arr[i].isDeleted
                                if (arr[i].updFile != undefined && arr[i].updFile != '') {
                                    let arrFile = arr[i].updFile.split(',')
                                    for (let j = 0; j < arrFile.length; j++) {
                                        array.updFile.push(arrFile[j])
                                    }
                                }
                                this.tableData.push(array)
                            }
                        }
                        // this.tableData = response.data.list
                        this.searchParams.pageCount = response.data.total
                    }
                })
            },
            getData() {
                var self = this
                let options = {
                    method: 'GET',
                    url: this.$api.departTree
                }
                this.$http.request(options).then(response => {
                    this.factoryTree = response.data
                    for (var i = 0; i < self.factoryTree.length; i++) {
                        if (self.factoryTree[i].deptID == self.role.factoryId) {
                            self.fcIdSelected = JSON.stringify(self.factoryTree[i])
                        }
                    }
                    this.searchTable()
                })
            }
        }
    }
</script>

<style scoped>

</style>
